import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { AuthQuery } from '@ascschool/core/auth/auth.query';
import { AuthService } from '@ascschool/core/auth/auth.service';
import { AuthStore } from '@ascschool/core/auth/auth.store';
@Injectable({ providedIn: 'root' })
export class AuthGuard implements CanActivate {
  constructor(private router: Router, private authStore: AuthStore, private authQuery: AuthQuery) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    if (this.authQuery.isLoggedIn()) {
      return true;
    }
    this.router.navigate(['/dangnhap'], { queryParams: { returnUrl: state.url } });
    return false;
  }
}
